import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
// import DefaultUserGroupAction from "app/components/Base/DefaultUserGroup/DefaultUserGroupAction"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class RegisterTemplateActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Base/RegisterTemplate/RegisterTemplateBrowser")
	}

	render() {
		return (
			<Activity 
				name="RegisterTemplate"
				RenderedComponent={this.RenderedComponent}
                context="RegisterTemplate"
                // formActions={DefaultUserGroupAction}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(RegisterTemplateActivity)
